import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Page from "components/Page";
import constants from "./../../../../../../constants";
import Text from "components/Text";
import styles from "../../../Appointments.module.scss";
import appointmentStyles from "../../../Appointments.module.scss";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  useGlobalRemidnerPlanDetail,
  useRemidnerPlanDetail,
} from "repositories/patient-appointment-repository";
import { decodeId, getStorage, setStorage } from "utils";
import Loader from "components/Loader";
import { AppointmentsContext } from "accountOwner/pages/Appointments/AppointmentsContext";
import { useQueryClient } from "react-query";
import editIcon from "../../../../../../assets/images/edit-icon.svg";
import { Tooltip } from "reactstrap";
import Card from "components/Card";
import Empty from "components/Empty";
import { useOfficeById, useOfficeDetail } from "repositories/office-repository";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import NotAccessible from "accountOwner/pages/ManagerDashboard/components/NotAccessible";

const KEY_NAME_ONE = "appointment-reminder";
const KEY_NAME_GLOBAL = "global-appointment-reminder";
const ReminderPlan = ({ t }) => {
  const history = useHistory();
  const { appointmentId } = useParams();
  const { officeId } = useParams();
  const { patientId } = useParams();
  const {
    ownerList,
    commonOwnerData: selectedOwner,
    isStaff,
    dataAccessValues,
    selectedOwnerIdString,
  } = useAccountOwnerCommon();
  const [tooltipEditOpen, setTooltipEditOpen] = useState(false);
  const { reminderPlan, options, setReminderPlan, ownerId } =
    useContext(AppointmentsContext);
  const isNotGlobalPage = officeId || appointmentId || patientId;
  const decodeAppointmentId = parseInt(decodeId(appointmentId));
  const decodeOfficeId = officeId ? parseInt(decodeId(officeId)) : undefined;
  const decodePatientId = parseInt(decodeId(patientId));
  const { data: officeDetail } = useOfficeDetail(decodeOfficeId, {
    enabled: decodeOfficeId !== undefined,
  });
  const queryClient = useQueryClient();
  const location = useLocation();
  const isRecallReminderPlan = getStorage("isRecallReminderPlan");
  const { state } = location;
  const KEY_NAME = appointmentId ? KEY_NAME_ONE : KEY_NAME_GLOBAL;
  const { data: officeData } = useOfficeById(decodeOfficeId);
  const goBack = () => {
    if(window.history.length > 1){
     return history.goBack();
    }
    if (patientId) {
      history.push({
        pathname: constants.routes.appointment.patients.replace(
          ":officeId",
          officeId
        ),
        state: { officeName: state?.officeName },
      });
    } else if (officeId && !patientId) {
      history.push({
        pathname: constants.routes.accountOwner.timelinePreferences.replace(
          ":officeId",
          officeId
        ),
        state: { officeName: state?.officeName },
      });
    } else if (!patientId && !officeId) {
      history.push({
        pathname: constants.routes.accountPreferences,
        state: { officeName: state?.officeName },
      });
    } else {
      setStorage("appointmentReminder", {
        appointmentReminder: false,
      });
      history.push({
        pathname: constants.routes.appointment.appointmentScreen,
        state: { officeName: state?.officeName },
      });
    }
  };

  const {
    isLoading,
    data,
    refetch: defaultAppointmentFetch,
  } = useRemidnerPlanDetail(decodeAppointmentId, {
    enabled: !!decodeAppointmentId,
  });

  let reminderPlanType = 2;
  if (patientId && !isRecallReminderPlan?.isRecallReminderPlan) {
    reminderPlanType = 2;
  }

  if (patientId && isRecallReminderPlan?.isRecallReminderPlan) {
    reminderPlanType = 5;
  }

  if (officeId && !patientId && !isRecallReminderPlan?.isRecallReminderPlan) {
    reminderPlanType = 3;
  }

  if (officeId && !patientId && isRecallReminderPlan?.isRecallReminderPlan) {
    reminderPlanType = 6;
  }

  if (!patientId && !officeId && !isRecallReminderPlan?.isRecallReminderPlan) {
    reminderPlanType = 4;
  }

  if (!patientId && !officeId && isRecallReminderPlan?.isRecallReminderPlan) {
    reminderPlanType = 7;
  }

  const ownerIdForAllPages = decodeOfficeId ? officeDetail?.owner?.id : ownerId;
  const shouldFetchGlobalReminder = !!reminderPlanType && !!ownerIdForAllPages;
  const {
    isLoading: globalReminderLoading,
    isFetching: globalReminderFetching,
    data: globalRemidnerData,
  } = useGlobalRemidnerPlanDetail(
    decodeOfficeId,
    ownerIdForAllPages,
    decodePatientId,
    reminderPlanType,
    { enabled: shouldFetchGlobalReminder }
  );

  useEffect(() => {
    if (appointmentId) {
      setStorage("appointmentReminder", {
        appointmentReminder: true,
      });
    }
  }, []);

  const redirectSelectReminder = (e) => {
    if (e.target.closest(".interactive-element")) {
      return;
    }
    if (appointmentId) {
      history.push({
        pathname: constants.routes.appointment.appointmentReminder
          .replace(":officeId", officeId)
          .replace(":requestId", appointmentId),
        state: { isFromGloabList: true, officeName: state?.officeName },
        search:selectedOwnerIdString?`?${selectedOwnerIdString}`:""
      });
    } else {
      history.push({
        pathname: constants.routes.appointment.patientAppointmentReminder
          .replace("/:officeId?", officeId ? `/${officeId}` : "")
          .replace("/:patientId?", patientId ? `/${patientId}` : ""),
        state: { isFromGloabList: true, officeName: state?.officeName },
        search:selectedOwnerIdString?`?${selectedOwnerIdString}`:""
      });
    }
  };

  const fetchDefaultData = async () => {
    queryClient.invalidateQueries([
      "/AppointmentReminder/ReminderPlanMappingByAppointmentId",
      decodeAppointmentId,
    ]);
    const refetchData = await defaultAppointmentFetch();
    if (refetchData?.data?.appointmentReminderPlanMappings?.length) {
      setReminderPlan((prevReminderPlan) => ({
        ...prevReminderPlan,
        [KEY_NAME]: {
          title: refetchData?.data?.appointmentReminderPlan?.title,
          id: refetchData?.data?.appointmentReminderPlan?.id,
          appointmentReminderPlanSetting: [
            ...refetchData?.data?.appointmentReminderPlanMappings,
          ],
        },
      }));
    }
  };

  const syncGlobalReminderPlanState = (planData) => {
    if (planData?.appointmentReminderPlanSetting?.length) {
      setReminderPlan((prevReminderPlan) => ({
        ...prevReminderPlan,
        [KEY_NAME]: {
          title: planData?.title,
          id: planData?.id,
          reminderPlanType: planData?.reminderPlanType,
          appointmentReminderPlanSetting: [
            ...planData.appointmentReminderPlanSetting,
          ],
        },
      }));
      return;
    }

    setReminderPlan((prevReminderPlan) => ({
      ...prevReminderPlan,
      [KEY_NAME]: null,
    }));
  };

  const handleAddRemidnerRedirection = () => {
    history.push({
      pathname: constants.routes.appointment.patientAddAppointmentReminderPlan
        .replace("/:officeId?", officeId ? `/${officeId}` : "")
        .replace("/:patientId?", patientId ? `/${patientId}` : ""),
      state: { officeName: state?.officeName },
      search:selectedOwnerIdString?`?${selectedOwnerIdString}`:""
    });
  };

  useEffect(() => {
    if (appointmentId) {
      return;
    }

    setReminderPlan((prevReminderPlan) => ({
      ...prevReminderPlan,
      [KEY_NAME]: null,
    }));
  }, [appointmentId, ownerIdForAllPages]);

  useEffect(() => {
    if (appointmentId) {
      if (!isLoading) {
        fetchDefaultData();
      }
      return;
    }

    if (globalReminderLoading || globalReminderFetching) {
      return;
    }

    syncGlobalReminderPlanState(globalRemidnerData);
  }, [
    appointmentId,
    data,
    isLoading,
    globalReminderLoading,
    globalReminderFetching,
    globalRemidnerData,
    ownerIdForAllPages,
  ]);
  const officeName = state?.officeName || officeData?.name;

  const renderSwitchOwnerElement = isNotGlobalPage
    ? null
    : isStaff &&
      ownerList.length > 0 && selectedOwner?.id && (
            <div className="show-owner-name-text marginBottom30 mt-3">
              {t("accountPreferences.showingTemplates")}{" "}
              <span>
                '{selectedOwner.firstName} {selectedOwner.lastName}'
              </span>
              {t("dashBoard.office")}
            </div>
          
      );
  const mainDivRef = useRef(null);
  const [reCalCulate, setReCalCulate] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      if (mainDivRef.current?.clientHeight) {
        setReCalCulate(true);
      }
    }, 500);
  }, []);
  const heightCalculate = useMemo(() => {
    if (
      isStaff &&
      mainDivRef.current &&
      mainDivRef.current?.clientHeight > 200
    ) {
      return mainDivRef.current?.clientHeight;
    }
    return "300px";
  }, [
    dataAccessValues,
    isStaff,
    reCalCulate,
    reminderPlan?.[KEY_NAME]?.appointmentReminderPlanSetting,
  ]);
  const globalPageCheck =
    !isNotGlobalPage && isStaff && !dataAccessValues?.isMessageTemplateModule;
  return (
    <Page onBack={goBack} className="main-page">
      {(isLoading || globalReminderLoading || globalReminderFetching) && <Loader />}
      <div className={styles.btn_flex_cont}>
        <div className="d-flex flex-column manage-schedule-heading">
          <p
            className={
              styles["mobile-text-size"] +
              (officeName ? " page_title_margin_bottom" : " mb-0")
            }
          >
            {isRecallReminderPlan?.isRecallReminderPlan
              ? t("accountPreferences.appointmentRecallPlan")
              : t("accountPreferences.appointmentReminderPlan")}
          </p>
          {!!officeName && <p className="pms_subtitle">{officeName}</p>}
        </div>
        {(appointmentId || globalRemidnerData?.id) && !globalPageCheck ? (
          <>
            <button
              className={styles.edit_recall_btn}
              onClick={redirectSelectReminder}
              id="edit_icon"
            >
              <img src={editIcon} alt="edit" />
            </button>
            <Tooltip
              isOpen={tooltipEditOpen}
              placement="top"
              target="edit_icon"
              toggle={() => {
                setTooltipEditOpen(!tooltipEditOpen);
              }}
            >
              {t("discussionNote.edit")}
            </Tooltip>
          </>
        ) : globalPageCheck ? null : (
          <div onClick={handleAddRemidnerRedirection} className="w-sm-100">
            <button className="button button-round button-shadow mr-md-4 w-sm-100">
              {t("patientAppointmentMembers.addNewReminderPlan")}
            </button>
          </div>
        )}
      </div>
      <div ref={mainDivRef}>
        {globalPageCheck ? (
          <>
            {renderSwitchOwnerElement}
            <div
              className="not-accessible center_property"
              style={{ height: heightCalculate }}
            >
              <NotAccessible
                Message={t("dashBoard.notAccessibleModulePleaseSwitchOwner")}
              />
            </div>
          </>
        ) : reminderPlan?.[KEY_NAME]?.appointmentReminderPlanSetting?.length ? (
          <>
            <Text size="14px" weight="300" color="#000000" marginTop="10px">
              {t("patientAppointmentMembers.reminderPlan")}
            </Text>
            {renderSwitchOwnerElement}
            {reminderPlan?.[KEY_NAME] && (
              <Card
                className={
                  appointmentStyles["appointment_modal_card_new"] +
                  " " +
                  "form-wrapper"
                }
              >
                <Text size="14px" weight="600" color="#102C42">
                  {reminderPlan?.[KEY_NAME]?.title || ""}
                </Text>
                {reminderPlan?.[KEY_NAME]?.appointmentReminderPlanSetting?.map(
                  (plan, index) => (
                    <div className={styles.recall_small_card} key={plan?.id}>
                      <Text
                        size="16px"
                        weight="600"
                        color="#111B45"
                      >{`Reminder ${index + 1}`}</Text>
                      <Text
                        size="14px"
                        weight="600"
                        color="#102C42"
                        marginTop="4px"
                      >
                        {plan?.reminderBefore +
                          " " +
                          options.find((m) => m.id == plan?.reminderBeforeType)
                            ?.name +
                          " " +
                          t("patientAppointmentMembers.before")}
                      </Text>
                      <Text
                        size="14px"
                        weight="500"
                        color="#102C42"
                        marginTop="4px"
                      >
                        {[
                          plan.isEmail &&
                            t("patientAppointmentMembers.isEmail"),
                          plan.isSms && t("patientAppointmentMembers.isSms"),
                          plan.isPushNotification &&
                            t("patientAppointmentMembers.isPushNotification"),
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </Text>
                      <Text
                        size="12px"
                        weight="400"
                        color="#6F7788"
                        marginTop="6px"
                      >
                        {t("patientAppointmentMembers.messageTemPlate")}
                      </Text>
                      <Text size="14px" weight="500" color="#102C42">
                        {plan?.messageTemplateDetail?.templateName}
                      </Text>
                    </div>
                  )
                )}
              </Card>
            )}
          </>
        ) : (
          <>
            {renderSwitchOwnerElement}
            <Empty
              Message={
                isRecallReminderPlan?.isRecallReminderPlan
                  ? t("patientAppointmentMembers.recallReminderNotFound")
                  : t("patientAppointmentMembers.reminderNotFound")
              }
            />
          </>
        )}
      </div>

     
    </Page>
  );
};
export default withTranslation()(ReminderPlan);
